import { useMutation } from '@tanstack/react-query'

import { api } from 'src/common/api'

interface GetFullEarningsReportParams {
  esdUniqueId: string
}

const useGenerateFullEarningsReport = () => {
  return useMutation({
    mutationFn: async (data: GetFullEarningsReportParams) =>
      api.post(
        `/v1/washington-state/build-full-driver-earnings-report/${data.esdUniqueId}`,
      ),
  })
}

export default useGenerateFullEarningsReport
